import { render, staticRenderFns } from "./ParticipantReset.vue?vue&type=template&id=106d9953&scoped=true"
import script from "./ParticipantReset.vue?vue&type=script&lang=js"
export * from "./ParticipantReset.vue?vue&type=script&lang=js"
import style0 from "./ParticipantReset.vue?vue&type=style&index=0&id=106d9953&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106d9953",
  null
  
)

export default component.exports